export default function Board(props) {
    return (
        <div className="mx-10 h-[32rem] bg-green-700 rounded-xl shadow-xl p-5 text-2xl">
            {props.children}
        </div>
    )
}